import { Box, Button, Grid, Stack, Typography } from "@mui/material";
import React, { FC, useState } from "react";
import { useTheme } from "@mui/material/styles";
import { ScheduleIcon } from "../UIElements/svgIcons";
import CalendarComponent from "./scheduleCalendar";

import useResponsive from "../../hooks/useResponsive";
import { btnSty } from "../ui-styles";

import { ScheduleContentsProps } from "../../interface/schedule";

import { InfoBox } from "../designUi";
import { AssignSchedule } from "./ScheduleModal";
import ScheduleTableContainer from "./scheduleTableContainer";

const ScheduleContent: FC<ScheduleContentsProps> = ({
  scheduleList,
  setRefresh,
  loading,
  setFilterData,
  paginationState,
  setPaginationState,
  viewMode,
  setViewMode,
}) => {
  const theme = useTheme();
  const isSmall = useResponsive("down", "sm", "xl");

  const [scheduleModal, setScheduleModal] = useState(false);

  const handleScheduleModal = () => {
    setScheduleModal(!scheduleModal);
  };
  
  return (
    <Box sx={{ padding: 3 }}>
      <AssignSchedule
        open={scheduleModal}
        setRefresh={setRefresh}
        modalHandler={handleScheduleModal}
      />
      {/* <AppriasalSchedule /> */}
      <Stack
        direction={isSmall ? "column" : "row"}
        alignItems={"center"}
        justifyContent={"space-between"}
        sx={{ paddingX: 2, mt: 3 }}
      >
        <Typography
          variant="subtitle2"
          color={"neutral"}
          sx={{ fontWeight: 700, fontFamily: "Inter" }}
        >
          Schedules
        </Typography>
        <Stack
          direction={isSmall ? "column" : "row"}
          sx={{ gap: isSmall ? 2 : 4, my: 2 }}
        >
          <Button
            onClick={handleScheduleModal}
            variant="contained"
            
            sx={{
              
              
            }}
          >
            <img
              src="/assets/icons/calendar.svg"
              alt="icon"
              width={22}
              height={22}
              style={{margin: "0 10px"}}
            />
            Generate Schedule
          </Button>
        </Stack>
      </Stack>
      <Grid container>
        <Grid
          item
          xs={isSmall ? 12 : 5}
          sx={{ paddingX: isSmall ? 0 : 2, paddingY: 2 }}
        >
          <InfoBox
            title={"Total Schedule"}
            value={scheduleList?.length}
            icon={<ScheduleIcon />}
          />
        </Grid>
      </Grid>
      {/* <Box sx={{ display: "flex", flexDirection: isSmall ? "column" : "row" }}>
        <ScheduleBox
          shift="Morning Shift"
          time="8:00am - 12:00pm"
          days="Weekday"
        />
        <ScheduleBox
          shift="Afternoon Shift"
          time="8:00am - 12:00pm"
          days="Weekday"
        />
      </Box> */}
      {viewMode ? (
        <ScheduleTableContainer
          setRefresh={setRefresh}
          setFilterData={setFilterData}
          paginationState={paginationState}
          setPaginationState={setPaginationState}
          scheduleList={scheduleList}
          loading={loading}
        />
      ) : (
        <Box sx={{ p: 3, background: "white", my: 3 }}>
          <CalendarComponent
            setRefresh={setRefresh}
            scheduleList={scheduleList}
          />
        </Box>
      )}
    </Box>
  );
};

export default ScheduleContent;
